<template>
  <b-card title="Parámetros del Sistema">
    <b-form @submit.prevent="saveParams">
      <b-row>
        <!-- Parámetro 1 -->
        <b-col md="6">
          <b-form-group label="Periodo de Asignación Automática (días)">
            <b-form-input
              v-model.number="params.autoAssignPeriod"
              type="number"
            />
          </b-form-group>
        </b-col>

        <!-- Parámetro 2 -->
        <b-col md="6">
          <b-form-group label="Máximo de Cursos por Estudiante">
            <b-form-input
              v-model.number="params.maxCoursesPerStudent"
              type="number"
            />
          </b-form-group>
        </b-col>

        <!-- Parámetro 3 -->
        <b-col md="6">
          <b-form-group label="Notificaciones por Email">
            <b-form-checkbox
              v-model="params.emailNotifications"
              switch
              class="mt-1"
            >
              {{ params.emailNotifications ? 'Activadas' : 'Desactivadas' }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>

      </b-row>

      <b-button
        variant="primary"
        type="submit"
        class="mt-2"
      >
        Guardar Cambios
      </b-button>
    </b-form>
  </b-card>
</template>

<script>
import { BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BButton } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
  },
  data() {
    return {
      params: {
        autoAssignPeriod: 30,
        maxCoursesPerStudent: 6,
        emailNotifications: true,
      },
    }
  },
  methods: {
    saveParams() {
      // Lógica para guardar parámetros (simulada)
      console.log('Parámetros guardados:', this.params)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Operación Exitosa',
          icon: 'CheckIcon',
          variant: 'success',
          text: 'Los parámetros del sistema se han actualizado correctamente.',
        },
      })
    },
  },
}
</script>
